import React, { useEffect } from "react";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Chip,
  useTheme,
  Box,
  Typography,
} from "@mui/material";
import { v4 } from "uuid";
import { Filter, RenderIf } from "@adl/smart-ui-library";

type Props = {
  onUpdate: (data: any) => void;
  details: any;
  caseDetails?: any;
};

const CaseDetails = ({ onUpdate, details, caseDetails }: Props) => {
  const [rowData, setRowData] = React.useState<any[] | null>(null);
  const theme = useTheme();

  useEffect(() => {
    const rows = [
      {
        id: "Client Name",
        value: [
          {
            type: "clientName",
            label: caseDetails?.AccountName,
            value: caseDetails?.AccountName,
            param: caseDetails?.AccountName,
          },
        ],
      },
      {
        id: "Industry Practice",
        value: [
          {
            type: "industryPractice",
            label: caseDetails?.MainProjectIndustry,
            value: caseDetails?.MainProjectIndustry,
            param: caseDetails?.MainProjectIndustry,
          },
        ],
      },
      {
        id: "Functional  Practice",
        value: [
          {
            type: "functionalPractice",
            label: caseDetails?.MainFunctionalPractice,
            value: caseDetails?.MainFunctionalPractice,
            param: caseDetails?.FunctionalPractice,
          },
        ],
      },
      {
        id: "Market",
        value: [
          {
            type: "markets",
            label: caseDetails?.Market,
            value: caseDetails?.Market,
            param: caseDetails?.Market,
          },
        ],
      },
    ];

    setRowData(rows);
  }, [caseDetails]);

  return (
    <Box>
      <Typography variant="h6" sx={{ marginBottom: "15px" }}>
        Case Details
      </Typography>
      <TableContainer component={Box}>
        <Table
          sx={{
            border: `1px solid ${theme.palette.grey[300]}`,
          }}
        >
          <TableBody>
            {rowData?.map((row) => {
              return (
                <TableRow
                  key={v4()}
                  sx={{
                    "td, th": {
                      borderBottom: `1px solid ${theme.palette.grey[300]}`,
                    },
                  }}
                >
                  <TableCell sx={{ width: "150px" }}>
                    <Typography variant="h3">{row.id}</Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                      {row.value.map((item) => (
                        <Chip key={v4()} label={item.label} />
                      ))}
                    </Box>
                  </TableCell>
                  <TableCell align="right">
                    <RenderIf isTrue={false}>
                      <Filter
                        title={`Add`}
                        onApplyFilter={(filters) => {
                          const clone = { ...details };
                          const map = filters.map((filter) => {
                            return filter.value;
                          });
                          clone[row.id.toLowerCase()] = map;
                          onUpdate(clone);
                        }}
                        multiple={row.id === "Budget Currency" ? false : true}
                        search
                        selectedItems={row.value}
                        config={row.options}
                      />
                    </RenderIf>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};
export default CaseDetails;

/*
      
      */
